import { Controller } from "stimulus"

export default class extends Controller {
  connect() {
    this.element.classList.remove('is-collapsed')

    if (window.matchMedia) {

    }
  }

  toggle() {
    this.element.classList.toggle('is-collapsed')
  }
}
